<template>
    <q-page padding class="productos-index-page">
        <ProductoGrid />
    </q-page>
</template>

<script setup>
import ProductoGrid from './components/ProductoGrid.vue';
</script>
